module.exports = __webpack_public_path__ + "img/summary_background_SZP.a12cb65a.jpg";